/* eslint-disable camelcase */
import { createDatePicker } from "../../common/helpers";
import { buscarPedimentos } from "./descarga.buscar";
import { handleCancelarDescarga } from "./descarga.finalizar";
import { DescargaCommonGlobal } from "./descarga.global";
import {
    handleProcesarDescarga,
    initProcesoDescarga,
} from "./descarga.procesar";
import { handleSiguienteMaterial } from "./descarga.recorrido";
import { isPedimentosExportacionSeleccionados } from "./utils";
import {
    btnDescarga,
    handleMostrarListaMateriales,
    handleMostrarInformacionPedimento,
} from "./view";

// -------------------------------------------------------------
// Init Date Picker
// -------------------------------------------------------------

const datePickerCallback = (start, end) => {
    DescargaCommonGlobal.fechaInicio = start.format("YYYY-MM-DD");
    DescargaCommonGlobal.fechaFin = end.format("YYYY-MM-DD");
};

createDatePicker(datePickerCallback);

// -------------------------------------------------------------
// Export Action Buttons
// -------------------------------------------------------------

/**
 * Busqueda de pedimentos de Exportación para descargar
 */
export const onClickBtnBuscarPedimentos = buscarPedimentos;

/**
 * Simulación de descarga de mercancías o iniciar con el proceso
 */
export const onClickBtnDescargaOrSimulacion = () => {
    const innerTextHTMLButttonDescarga = btnDescarga.innerHTML.toString();

    const isIniciarProcesoDescarga = innerTextHTMLButttonDescarga.match(
        ".*Iniciar proceso de descarga.*",
    );

    if (isIniciarProcesoDescarga) {
        if (isPedimentosExportacionSeleccionados()) {
            initProcesoDescarga();
        }
    } else {
        handleProcesarDescarga();
    }
};

/**
 * Pasar al siguiente material del recorrido
 */
export const onClickBtnSiguienteMaterial = handleSiguienteMaterial;

/**
 * Cancelar descargo
 */
export const onClickBtnCancelarDescargo = handleCancelarDescarga;

/**
 * Confirmar la descarga y continuar
 */
export const onClickBtnConfirmarDescarga = handleProcesarDescarga;

/**
 * Muestra la información o el detalle del pedimento de exportación
 */
export const onClickBtnMostrarInfoPedimento = handleMostrarInformacionPedimento;

/**
 * Muestra la lista de materiales que se recorre actualmente
 */
export const onClickBtnMostrarListaMateriales = handleMostrarListaMateriales;
